const DefaultImage = "/images/logos/default.png";
const EmptyState = "/images/svg/empty-search.svg";

const Logo = "/images/logos/logo.png";
const LogSm = "/images/logos/logo_sm.png";

const SidebarLogo = "/images/logos/sidebar-logo.png";
const SidebarLogoIcon = "/images/logos/sidebar-logo-sm.png";

const Banner1 = "/images/banners/banner-1.jpg";
const Banner2 = "/images/banners/banner-2.jpg";
const Banner3 = "/images/banners/banner-3.jpg";
const Banner4 = "/images/banners/banner-4.jpg";
const Banner5 = "/images/banners/banner-5.jpg";
const Banner6 = "/images/banners/banner-6.jpg";

const pdfImage = "/images/pngs/pdf.png";
const docImage = "/images/pngs/doc.png";

// const Google = "/images/svg/google.svg";

export const Pngs = { pdfImage, docImage };

export const Logos = { Logo, LogSm, SidebarLogo, SidebarLogoIcon };

export const Banners = { Banner1, Banner2, Banner3, Banner4, Banner5, Banner6 };

// PLANA IMAGES

const FallBackImg = "/images/misc/fallback-image.png";
const BlurImage = "/images/misc/blur.webp";

const SingleDetached = "/images/pngs/single-detached.jpg";

// const Google = "/images/svg/google.svg";

// import Google from "./public/images/svg/google.svg";
// import LogoTxt from "./public/images/svg/logo.svg";

const Google = "/images/pngs/google.png";
const LogoTxt = "/images/svg/logo.svg";

export const Svg = { Google, LogoTxt };

export { FallBackImg, BlurImage, DefaultImage, SingleDetached, EmptyState };
